function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "684px",
    height: "652px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d9488",
    d: "M 336.5,0.5 C 377.22,1.09946 406.72,19.4328 425,55.5C 439.619,94.2361 432.786,128.569 404.5,158.5C 430.787,206.243 457.453,253.743 484.5,301C 485.5,301.667 486.5,301.667 487.5,301C 504.333,284.833 521.167,268.667 538,252.5C 527.195,215.248 537.362,185.082 568.5,162C 605.746,142.983 638.58,148.816 667,179.5C 683.679,202.648 687.013,227.648 677,254.5C 667.826,273.841 653.326,287.508 633.5,295.5C 627.006,352.112 620.839,408.778 615,465.5C 612.073,503.401 604.739,540.401 593,576.5C 579.474,610.351 554.974,631.851 519.5,641C 499.116,645.798 478.45,648.465 457.5,649C 374.485,651.259 291.485,650.925 208.5,648C 182.081,647.145 157.081,640.812 133.5,629C 112.86,616.684 98.3604,599.184 90,576.5C 79.0365,543.35 72.0365,509.35 69,474.5C 62.4367,414.867 56.27,355.2 50.5,295.5C 22.5937,285.079 6.09375,265.079 1,235.5C -1.97975,207.083 7.52025,183.916 29.5,166C 59.0233,146.139 88.69,145.805 118.5,165C 146.703,188.278 155.536,217.444 145,252.5C 161.833,268.667 178.667,284.833 195.5,301C 196.784,301.684 197.951,301.517 199,300.5C 225.753,253.328 252.253,205.995 278.5,158.5C 249.487,127.433 242.987,92.0999 259,52.5C 275.723,21.5575 301.556,4.22414 336.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5eead4",
    d: "M 332.5,49.5 C 357.791,46.9782 374.625,57.6448 383,81.5C 387.022,100.775 381.188,116.275 365.5,128C 340.766,140.853 320.266,136.02 304,113.5C 293.719,91.457 297.886,72.6237 316.5,57C 321.542,53.6426 326.876,51.1426 332.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5eead4",
    d: "M 321.5,181.5 C 334.168,184.083 346.835,184.083 359.5,181.5C 360.167,181.833 360.833,182.167 361.5,182.5C 387.333,228.833 413.167,275.167 439,321.5C 453.825,346.553 475.325,355.387 503.5,348C 510.34,344.75 516.673,340.75 522.5,336C 538.029,320.138 553.862,304.638 570,289.5C 573.969,291.901 578.135,293.901 582.5,295.5C 582.833,296.167 583.167,296.833 583.5,297.5C 576.833,359.834 570.167,422.168 563.5,484.5C 415.5,484.5 267.5,484.5 119.5,484.5C 112.347,421.467 106.014,358.467 100.5,295.5C 104.865,293.901 109.031,291.901 113,289.5C 128.529,305.362 144.362,320.862 160.5,336C 179.732,352.618 200.732,355.285 223.5,344C 231.753,337.749 238.586,330.249 244,321.5C 270.111,274.94 295.945,228.273 321.5,181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5eead4",
    d: "M 67.5,199.5 C 91.5666,198.397 102.4,209.73 100,233.5C 92.2915,250.101 79.7915,255.268 62.5,249C 48.1112,238.945 44.9445,226.111 53,210.5C 56.9507,205.466 61.7841,201.799 67.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5eead4",
    d: "M 601.5,199.5 C 616.358,197.209 626.858,202.876 633,216.5C 636.877,232.913 631.044,244.413 615.5,251C 595.665,253.419 584.332,244.752 581.5,225C 582.808,212.203 589.475,203.703 601.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5eead4",
    d: "M 128.5,532.5 C 270.5,532.333 412.5,532.5 554.5,533C 552.943,548.326 547.776,562.493 539,575.5C 528.544,586.647 515.711,593.48 500.5,596C 485.957,598.721 471.29,600.388 456.5,601C 379.833,601.667 303.167,601.667 226.5,601C 206.742,600.614 187.409,597.614 168.5,592C 153.153,586.653 142.32,576.486 136,561.5C 132.565,552.863 129.732,544.029 127.5,535C 127.743,534.098 128.077,533.265 128.5,532.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.8cc40536b641fcb284ac0eef4ddb4c3d.svg";
export { ForwardRef as ReactComponent };